/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAllFollowedUsers = createAsyncThunk(
  "chat/AllFollowedUsers",
  async (obj: any, thunkAPI) => {
    const { chatClient, userChatId, search } = obj;
    const filters = {
      role: "user",
      id: { $ne: userChatId },
      ...(search && { name: { $autocomplete: search } }),
    };
    const response = await chatClient.queryUsers(filters);
    let followedUsers = [];
    if (response?.users?.length) {
      followedUsers = response.users.map((user: any) => {
        return {
          type: "messaging",
          user,
        };
      });
    }
    return followedUsers || [];
  },
);

export const getUser = createAsyncThunk(
  "chat/User",
  async (obj: any, thunkAPI) => {
    const { chatClient, userId } = obj;
    const response = await chatClient.queryUsers({ id: userId });
    if (response?.users?.length) {
      return response.users[0];
    }
    return null;
  },
);

export const getAllChattedChannel = createAsyncThunk(
  "chat/AllChattedChannel",
  async (obj: any, thunkAPI) => {
    const { chatClient, userChatId, search, type } = obj;
    const included_type =
      type === "team" ? ["team", "adminOnly"] : ["messaging"];
    try {
      let allChannel = await chatClient.queryChannels(
        {
          members: { $in: [userChatId] },
          type: { $in: included_type },
        },
        [{ last_message_at: -1 }],
        {
          message_limit: 1,
          limit: 100,
        },
      );
      if (search) {
        allChannel = allChannel.filter((channel: any) => {
          if (type === "team")
            return channel?.data?.name?.toLowerCase().includes(search);
          if (type === "messaging")
            return (
              Object.values(channel?.state?.members)?.findIndex((member: any) =>
                member.user.name.toLowerCase().includes(search),
              ) !== -1
            );
        });
      }
      const userIdDetails: any[] = [];
      if (allChannel.length > 0) {
        allChannel.forEach((channel: any) => {
          const messages = channel.state.messageSets[0].messages;
          if (channel?.type === "messaging") {
            const members = channel.state.members;
            const allKeys = Object.keys(members);
            const otherUser: any = allKeys?.find(
              (member: any) => member !== userChatId,
            );
            userIdDetails.push({
              type: "messaging",
              user: members?.[otherUser]?.user,
              messages: [...messages],
            });
          } else if (
            channel?.type === "team" ||
            channel?.type === "adminOnly"
          ) {
            const memberIds = Object.keys(channel?.state?.members);
            const members = memberIds.map(
              (id: string) => channel.state.members[id].user?.name,
            );
            userIdDetails.push({
              type: channel?.type,
              user: channel?.data,
              messages: [...messages],
              members,
            });
          }
        });
      }

      return allChannel || [];
    } catch (error) {
      return [];
    }
  },
);

export const getAllTeamChannelWithoutJoin = createAsyncThunk(
  "chat/AllTeamChannelWithoutJoin",
  async (obj: any, thunkAPI) => {
    const { chatClient, userChatId } = obj;

    const allChannel = await chatClient.queryChannels(
      {
        type: { $in: ["team", "adminOnly"] },
        members: {
          $nin: [userChatId],
        },
      },
      {
        limit: 100,
      },
    );
    const userIdDetails: any[] = [];
    if (allChannel.length > 0) {
      allChannel.forEach((channel: any) => {
        const messages = channel.state.messageSets[0].messages;
        userIdDetails.push({
          type: "team",
          user: channel?.data,
          id: channel?.id,
          is_joined: false,
          messages: [...messages],
        });
      });
    }
    return userIdDetails || [];
  },
);

// export const getAllTeamChannelWithJoin = createAsyncThunk("chat/AllTeamChannelWithJoin", async (obj: any, thunkAPI) => {
//     const { chatClient, userChatId } = obj
//     const allChannel = await chatClient.queryChannels({
//         type: 'team',
//         members: { $in: [userChatId] },
//     })
//     let userIdDetails: any[] = [];
//     if (allChannel.length > 0) {
//         allChannel.forEach((channel: any) => {
//             if (channel?.type === 'team') {
//                 userIdDetails.push({
//                     type: 'team',
//                     user: channel?.data
//                 });
//             }
//         });
//     }
//     return userIdDetails || []
// });
